/**
 * Modo asistido: el onboarding lo opera un asistente y no el cliente final (AB#10758).
 *
 * Entra por el parametro 'a' del link del operador y <code>page.tsx</code> lo guarda en
 * sessionStorage. Hace falta guardarlo porque todas las pantallas de error rearman la url de vuelta
 * al inicio desde cero -entidad, tipo de flujo, ref_id, solicitud juridica- y ahi el parametro
 * original ya no esta: sin esto, un operador que vuelve desde un error aterriza en autoasistido,
 * le reaparece el check de terminos y el boton Iniciar le queda bloqueado.
 *
 * Es una senal manual y no un control: quien quiera puede abrir el link sin el parametro. La senal
 * definitiva -flag de entidad, o ingesta de sucursal/usuario- corresponde a AB#10734 / RF-BO-12, y
 * cuando exista se reemplaza aca y en la lectura de page.tsx, sin tocar las pantallas.
 */

export const CLAVE_MODO_ASISTIDO = 'asistido';

/** Si la sesion venia en modo asistido, el sufijo que hay que arrastrar a la url de inicio. */
export const sufijoModoAsistido = () => (sessionStorage.getItem(CLAVE_MODO_ASISTIDO) === '1' ? '&a=1' : '');
